// Yarn metadata: colours, names, and source descriptions for the four yarns
// of The Weave's loom.

export const YARNS = {
  centre: {
    key: "centre",
    label: "Centre",
    pastel: "#fae2b5",
    deep: "#f8d799",
    accent: "#b8862e",
    source: "Sandrine, Head of Community Wellbeing",
    promise: "An affirmation in The Weave voice",
    blurb:
      "Original affirmations written by Sandrine — the human signature of the loom. Founder-appropriate, never saccharine, always considered.",
  },
  sharpen: {
    key: "sharpen",
    label: "Sharpen",
    pastel: "#a7d5e5",
    deep: "#87c5db",
    accent: "#0f5b78",
    source: "HBR canon · field-tested practice",
    promise: "An actionable tip, attributed",
    blurb:
      "A hand-curated library of tips drawn from the HBR Entrepreneur's Handbook and adjacent canonical sources. Rigour you can use today.",
  },
  reflect: {
    key: "reflect",
    label: "Reflect",
    pastel: "#f6b1ae",
    deep: "#f29490",
    accent: "#892620",
    source: "Business · philosophy · literature",
    promise: "A fully attributed quote",
    blurb:
      "A monthly-refreshed library of attributed quotes — from the boardroom, the library, and the long view. A pause, mid-week.",
  },
  act: {
    key: "act",
    label: "Act",
    pastel: "#d0b6d1",
    deep: "#be9bbf",
    accent: "#5e3461",
    source: "Trending · grants · this week",
    promise: '"What if…" — a concrete next move',
    blurb:
      "The dynamic layer. A weekly human-reviewed sweep of articles, grants, podcasts and design prompts — surfaced as one specific next move.",
  },
};

export const YARN_ORDER = ["centre", "sharpen", "reflect", "act"];
